import _Chip from "@material-ui/core/esm/Chip";
import React from 'react';
import CSSclasses from './clear-filters-item.scss';
const styles = {
  root: CSSclasses.clearAllChip
};
export const ClearFiltersItem = ({
  onClick
}) => /*#__PURE__*/React.createElement("div", {
  className: CSSclasses.chip,
  "data-label": "ClearAll"
}, /*#__PURE__*/React.createElement(_Chip, {
  classes: styles,
  label: "Clear all",
  "aria-label": "Clear all",
  onClick: onClick
}));